import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';

interface CallToActionProps {
  title?: string;
  subtitle?: string;
  phoneNumber?: string;
  variant?: 'primary' | 'secondary' | 'accent';
  className?: string;
}

const CallToAction: React.FC<CallToActionProps> = ({
  title = "Vuoi confrontare le offerte?",
  subtitle = "Parla con un nostro consulente per una consulenza gratuita e senza impegno",
  phoneNumber = "+390698960166",
  variant = 'primary',
  className = '',
}) => {
  const bgStyles = {
    primary: 'bg-gradient-to-br from-primary to-[#006D6D]',
    secondary: 'bg-gradient-to-br from-secondary to-[#E06400]',
    accent: 'bg-gradient-to-br from-accent to-[#5A4BD6]',
  };

  return (
    <div className={`${bgStyles[variant]} py-16 px-6 md:px-10 rounded-2xl shadow-xl relative overflow-hidden ${className}`}>
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-60 h-60 bg-white rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-40 h-40 bg-white rounded-full blur-2xl" />
      </div>
      <div className="container mx-auto relative z-10">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between">
          <div className="mb-8 md:mb-0 md:mr-8">
            <h2 className="text-3xl font-extrabold mb-3 text-white font-display">{title}</h2>
            <p className="text-lg text-white/80">{subtitle}</p>
            <p className="text-sm text-white/50 mt-2">Consulenza gratuita · Nessun obbligo · La scelta è tua</p>
          </div>
          <div className="flex-shrink-0">
            <a 
              href={`tel:${phoneNumber}`} 
              className="btn bg-white text-primary hover:bg-white/90 flex items-center justify-center shadow-lg hover:shadow-xl text-base"
            >
              <FontAwesomeIcon icon={faPhone} className="mr-2" />
              Consulenza Gratuita
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;
